import campaignActionSharedMutations from '../../../campaign-action-shared/store/mutations'

export default {
  ...campaignActionSharedMutations,

  doneEditingAttendingShifts(state) {
    state.editingAttendingShifts = false
  },

  editAttendingShifts(state) {
    state.editingAttendingShifts = true
  },

  hideConfirmNotAttendingModal(state) {
    state.showConfirmNotAttendingModal = false
  },

  showConfirmNotAttendingModal(state) {
    state.showConfirmNotAttendingModal = true
  }
}
